import { render, staticRenderFns } from "./TandaTerima.vue?vue&type=template&id=3eaf273e"
import script from "./TandaTerima.vue?vue&type=script&lang=js"
export * from "./TandaTerima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports